import React from 'react';
import { Typography, Tooltip, useTheme } from '@mui/material';
import { formatToDealerTime } from 'utils/dateUtils';

interface CellDateTimeDealerProps {
  params: any;
  onClick?: () => void;
}

/**
 * Date+time cell formatted in the currently selected dealer's timezone, with the
 * 3-letter timezone abbreviation appended (e.g. "20 May 2026, 03:55 PM EDT").
 * Mirrors {@link CellDateTimeUTC} but uses {@link formatToDealerTime} so all grids
 * that need dealer-local timestamps render consistently.
 */
const CellDateTimeDealer = ({ params, onClick }: CellDateTimeDealerProps) => {
  const theme = useTheme();
  const rawValue = params?.value;
  const formattedDateTime = rawValue ? formatToDealerTime(rawValue) : '--';
  const displayValue =
    formattedDateTime && formattedDateTime !== 'Invalid Date'
      ? formattedDateTime
      : '--';

  return (
    <Tooltip title={displayValue}>
      <Typography
        component="span"
        sx={{
          fontSize: '14px',
          color: theme.palette.text.primary,
          cursor: onClick ? 'pointer' : 'default',
        }}
        onClick={onClick}
      >
        {displayValue}
      </Typography>
    </Tooltip>
  );
};

export default CellDateTimeDealer;
